import React, { useContext } from 'react';
import { Flex, Tag } from 'antd';
import { sortBy } from 'lodash';

import UIContext from 'components/Utils/UIContext';
import Weight from 'components/controls/Weight';
import { getScoreColor } from 'utils/ranking';
import { getItemAlteredByScenario } from 'utils/rules';

interface ImpactRelationSectionProps {
	title: string;
	items: any[];
	scenario: any;
	// Retourne le lien (impact) existant pour cet item, ou undefined
	getLink: (item: any) => any | undefined;
	// Cycle create -> strength+1 -> delete ; gere par le parent
	onToggle: (item: any, link: any | undefined) => void;
	showTrend?: boolean;
	emptyMessage?: string;
}

// Section de relations a intensite (CheckableTag + pastille tendance + poids
// cyclable 1->2->3). Le toggle/maj d'etat est delegue au parent via onToggle.
export const ImpactRelationSection = (props: ImpactRelationSectionProps) => {
	const uiContext = useContext(UIContext);
	const filtered = (props.items || [])
		.map((i: any) => getItemAlteredByScenario(i, props.scenario))
		.filter((i: any) => i.enabled !== false);

	return (
		<Flex vertical className="mt-2">
			<div className="text-left mb-05">
				<strong>{props.title}</strong>
			</div>
			<div className="text-left">
				{filtered && filtered.length ? (
					sortBy(filtered, 'name').map((i: any) => {
						const link = props.getLink(i);
						return (
							<Tag.CheckableTag
								key={i.id}
								checked={!!link}
								onClick={() => { if (uiContext.canEdit) props.onToggle(i, link); }}
								className="ImpactedIndicator tag"
							>
								{props.showTrend !== false && (
									<div
										className={'Trend v' + i.trend}
										style={
											i.trend == '50'
												? {}
												: { background: getScoreColor(i.trend) }
										}
									></div>
								)}
								<span className="tag__label" title={i.name}>
									{i.name}
								</span>
								{link ? (
									<Weight onClick={() => {}}>{link.strength}</Weight>
								) : null}
							</Tag.CheckableTag>
						);
					})
				) : (
					<div
						className="text-center"
						style={{ color: 'var(--ant-color-text-tertiary)' }}
					>
						{props.emptyMessage}
					</div>
				)}
			</div>
		</Flex>
	);
};

export default ImpactRelationSection;
